import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { REIMBURSEMENT_STATUS_COLORS, REIMBURSEMENT_STATUS_LABELS } from '../constants';

const ReimbursementStatusBadge = ({ status }) => (
  <Chip
    label={REIMBURSEMENT_STATUS_LABELS[status] || status}
    color={REIMBURSEMENT_STATUS_COLORS[status] || 'default'}
    size="small"
  />
);

ReimbursementStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default ReimbursementStatusBadge;
